
// Function to format money with multicurrency support
function formatMoneyWithCurrency(cents, currency) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    let value = "";

    const formatWithDelimiters = (number, precision = 2, thousands = ",", decimal = ".") => {
        if (isNaN(number) || number === null) return 0;

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
        const cents = parts[1] ? `${decimal}${parts[1]}` : "";

        return dollars + cents;
    };

    // Currency-specific formats
    const currencyFormats = {
        USD: "${{amount}}", // e.g., $10.00
        GBP: "£{{amount}}", // e.g., £10.00
        EUR: "€{{amount}}", // e.g., €10.00
        JPY: "¥{{amount_no_decimals}}", // e.g., ¥1000 (no decimals)
        AUD: "A${{amount}}", // e.g., A$10.00
        INR: "₹{{amount}}", // e.g., ₹10.00
        CAD: "C${{amount}}", // e.g., C$10.00
        // Add more currencies as needed
    };

    const format = currencyFormats[currency] || "${{amount}}"; // Default to USD format

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    switch (format.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        default:
            value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
}


/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
